function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    const carouselButton = this.querySelector(".carousel__button");
    const articleUrl = this.querySelector("#Slide-article-" + this.currentPage);
    articleUrl && carouselButton.setAttribute("href", articleUrl.dataset.url);
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVersion();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const isRestocking = this.getRestockData();
    const currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    
    const colorIsRestocking = !!isRestocking.find((restock) => currentVariant.sku.includes(restock));
    const restockTime = this.getRestockTime().find((data) => data.includes(currentVariant.sku.substring(0, currentVariant.sku.length - 2)));
    const time = restockTime?.split('&')[1] || "1-2 weeks";

    const tapImageData = this.getTapImageData() || [];
    let currentTapImage = null;
    tapImageData.forEach((data) => {
      const [variantId, imageUrl] = (data || '').split('|');
      if (variantId && imageUrl && currentVariant.id.toString() === variantId) {
        currentTapImage = imageUrl;
      }
    });

    const q = this.getQuantityOption() || 1;
    const doubleAndPackImages = this.getDoubleAndPackImages();
    const doubleImageData = (doubleAndPackImages.doubleImages?.split(",") || []).map((data) => {
      const [variantId, imageUrl] = (data || '').split('|');
      if (variantId && imageUrl) return { variantId, imageUrl };
      return null;
    }).filter(item => item !== null);
    const packImageData = (doubleAndPackImages.packImages?.split(",") || []).map((data) => {
      const [variantId, imageUrl] = (data || '').split('|');
      if (variantId && imageUrl) return { variantId, imageUrl };
      return null;
    }).filter(item => item !== null);
    if (q === 2) {
      currentTapImage = doubleImageData.find(item => item.variantId === currentVariant.id.toString())?.imageUrl || currentTapImage;
    } else if (q === 5) {
      currentTapImage = packImageData.find(item => item.variantId === currentVariant.id.toString())?.imageUrl || currentTapImage;
    }

    this.currentVariant = {
      ...currentVariant,
      isRestocking: colorIsRestocking,
      restockTime: time,
      tapImage: currentTapImage,
    }
  }

  getCurrentCardProduct() {
    const currentProduct = document.querySelector(".product__buy .card-upsell-input:checked")?.value || "Standard";
    const currentColor = this.currentVariant.option1;
    
    const metalVariantData = JSON.parse(document.getElementById("shopify-metal-product").textContent);
    const cardVariantData = this.getVariantData();

    const currentVariant =
      currentProduct === "Metal"
        ? metalVariantData.find((variant) => variant.option1 === currentColor)
        : cardVariantData.find((variant) => variant.option1 === currentColor);

    const q = this.getQuantityOption() || 1;
    if (currentProduct === "Metal") {
      const metalTapImageData = this.getTapImageDataMetal() || [];
      const metalDoubleAndPackImages = this.getDoubleAndPackImagesMetal();
      const metalDoubleImageData = (metalDoubleAndPackImages.doubleImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      const metalPackImageData = (metalDoubleAndPackImages.packImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      let tapImage = null;
      if (q === 1) {
        tapImage = metalTapImageData.find((data) => {
          const [variantId, imageUrl] = (data || '').split('|');
          return variantId && imageUrl && currentVariant.id.toString() === variantId;
        });
        tapImage = tapImage ? tapImage.split('|')[1] : null;
      } else if (q === 2) {
        tapImage = metalDoubleImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      } else if (q === 5) {
        tapImage = metalPackImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      }
      currentVariant.tapImage = tapImage;
    } else {
      const cardDoubleAndPackImages = this.getDoubleAndPackImages();
      const cardDoubleImageData = (cardDoubleAndPackImages.doubleImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      const cardPackImageData = (cardDoubleAndPackImages.packImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      const cardTapImageData = this.getTapImageData() || [];
      let tapImage = null;
      if (q === 1) {
        tapImage = cardTapImageData.find((data) => {
          const [variantId, imageUrl] = (data || '').split('|');
          return variantId && imageUrl && currentVariant.id.toString() === variantId;
        });
        tapImage = tapImage ? tapImage.split('|')[1] : null;
      } else if (q === 2) {
        tapImage = cardDoubleImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      } else if (q === 5) {
        tapImage = cardPackImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      }
      currentVariant.tapImage = tapImage;
    }

    return {
      url: currentProduct === "Metal" ? "/products/dot-metal" : this.dataset.url,
      variant: currentVariant,
    };
  }

  getCurrentDisplayProduct() {
    const currentProduct = document.querySelector(".product__buy .message-upsell-input:checked")?.value || "Standard";
    const currentColor = this.currentVariant.option1;

    const displayBundleVariantData = JSON.parse(document.getElementById("shopify-display-bundle-product").textContent);
    const displayVariantData = this.getVariantData();

    const currentVariant =
      currentProduct === "Standard"
        ? displayVariantData.find((variant) => variant.option1 === currentColor)
        : displayBundleVariantData.find((variant) => variant.option1 === currentColor && variant.option2 === currentProduct);

    const q = this.getQuantityOption() || 1;
    if (currentProduct !== "Standard") {
      const singleImage = currentVariant.featured_image;
      const doubleAndPackImages = this.getDoubleAndPackImagesDisplayPlateBundle();
      const doubleImages = (doubleAndPackImages.doubleImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      const packImages = (doubleAndPackImages.packImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      
      let tapImage = null;
      if (q === 1) {
        tapImage = singleImage || null;
      } else if (q === 2) {
        tapImage = doubleImages.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      } else if (q === 5) {
        tapImage = packImages.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      }
      currentVariant.tapImage = tapImage;
      currentVariant.name = `dot.display bundle - ${currentColor}`;
    } else {
      const displayDoubleAndPackImages = this.getDoubleAndPackImages();
      const displayDoubleImageData = (displayDoubleAndPackImages.doubleImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      const displayPackImageData = (displayDoubleAndPackImages.packImages?.split(",") || []).map((data) => {
        const [variantId, imageUrl] = (data || '').split('|');
        if (variantId && imageUrl) return { variantId, imageUrl };
        return null;
      }).filter(item => item !== null);
      let tapImage = null;
      if (q === 1) {
        tapImage = currentVariant.featured_image.src || null;
      } else if (q === 2) {
        tapImage = displayDoubleImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      } else if (q === 5) {
        tapImage = displayPackImageData.find((item) => item.variantId === currentVariant.id.toString());
        tapImage = tapImage ? tapImage.imageUrl : null;
      }
      currentVariant.tapImage = tapImage;
    }

    return {
      url: currentProduct !== "Standard" ? "/products/dot-display-review-plate" : this.dataset.url,
      variant: currentVariant,
    };
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const variantImageBottom = document.getElementById("VariantImageBottom");
    const variantImage = document.getElementById("VariantImage");

    const preload = new Image();
    let newImageSrc = "";

    if (this.currentVariant.name.includes("dot.card")) {
      // Account for dot.metal upsell on card product page
      const cardVariant = this.getCurrentCardProduct().variant;
      if (cardVariant && cardVariant.tapImage) {
        newImageSrc = cardVariant.tapImage;
      } else if (cardVariant) {
        newImageSrc = cardVariant.featured_image.src;
      }
    } else if (this.currentVariant.name.includes("dot.display")) {
      const displayVariant = this.getCurrentDisplayProduct().variant;
      if (displayVariant && displayVariant.tapImage) {
        newImageSrc = displayVariant.tapImage;
      } else if (displayVariant) {
        newImageSrc = displayVariant.featured_image.src;
      }
    } else if (this.currentVariant.tapImage) {
      newImageSrc = this.currentVariant.tapImage;
    } else {
      newImageSrc = this.currentVariant.featured_image.src;
    }

    preload.src = newImageSrc;

    preload.onload = () => {
      variantImage.src = newImageSrc;

      if (variantImageBottom) {
        variantImageBottom.classList.add("crossfade-hidden");
      
        variantImageBottom.addEventListener("transitionend", () => {
          variantImageBottom.src = variantImage.src;
          variantImageBottom.classList.remove("crossfade-hidden");
          }, { once: true });
      }
    }
  }

  updateVersion() {
    if (!this.currentVariant) return;
    const version = this.currentVariant.option3;
    if (!version) return;
    
    const versionSupertext = document.querySelectorAll(".product-name-supertext");
    const rightTiles = document.querySelectorAll(".tiles-column-right");
    const rightTilesMobile = document.querySelectorAll(".product-info-tiles-main-mobile");
    const smallerImageContainer = document.querySelectorAll(".smaller-info-tile-images-container-pp");
    const combined = [...versionSupertext, ...rightTiles, ...rightTilesMobile, ...smallerImageContainer];
    
    combined.forEach((element) => {
      if (version === "1.0") {
        element.classList.add("version-1");
      } else {
        element.classList.remove("version-1");
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const q = this.getQuantityOption();

    const variantId = this.currentVariant.name.includes("dot.card")
      ? this.getCurrentCardProduct().variant?.id 
      : this.currentVariant.name.includes("dot.display")
        ? this.getCurrentDisplayProduct().variant?.id
        : this.currentVariant.id;
      
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${variantId}${q ? `&q=${q}` : ""}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const isCardProduct = this.currentVariant.name.includes("dot.card");
    const isDisplayProduct = this.currentVariant.name.includes("dot.display");
    const cardProduct = isCardProduct ? this.getCurrentCardProduct() : null;
    const displayProduct = isDisplayProduct ? this.getCurrentDisplayProduct() : null;

    const productVariantId = isCardProduct
      ? cardProduct.variant?.id
      : isDisplayProduct
        ? displayProduct.variant?.id
        : this.currentVariant.id;
    const productUrl = isCardProduct
      ? cardProduct.url
      : isDisplayProduct
        ? displayProduct.url
        : this.dataset.url;

    // Preemptively set button class to prevent add to cart button flash on variant change.
    // Must mirror the sold-out logic below exactly, or the button flashes the wrong state
    // until the fetch resolves.
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (productForm) {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      let soldOut;
      if (this.productIsBasic()) {
        soldOut =
          isCardProduct && !this.currentVariant.name.includes("Gift Card")
            ? !cardProduct.variant.available && !cardProduct.variant.isRestocking
            : !this.singleVariantInStock() && !this.currentVariant.isRestocking;
      } else if (isDisplayProduct) {
        soldOut = !displayProduct.variant.available && !displayProduct.variant.isRestocking;
      } else if (this.productIsPreorder()) {
        soldOut = !this.singleVariantInStock() && !this.currentVariant.isRestocking;
      } else {
        soldOut = !this.currentVariant.available && !this.currentVariant.isRestocking;
      }

      if (soldOut) {
        addButton.classList.add("sold-out");
        addButtonText.textContent = window.variantStrings.soldOut;
      } else if (this.productIsPreorder()) {
        addButton.classList.remove("sold-out");
        addButtonText.textContent = "Preorder";
      } else {
        addButton.classList.remove("sold-out");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    fetch(
      `${productUrl}?variant=${productVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const q = this.getQuantityOption() || 1;
        const priceItem = document.querySelector(".product__buy .price");
        const priceTiers = document.querySelectorAll(`.price-tier`);
        const priceItemText = document.querySelector(`.price-item.price-item--text`);
        const priceRegular = document.querySelector(`.price__regular`);
        const priceSale = document.querySelector(`.price__sale`);
        priceTiers.forEach((tier) => {
          const isCurrentTier = tier.classList.contains(`price-tier--${q}`);
          tier.style.display = isCurrentTier ? "inline-block" : "none";
        });
        if (q > 1 || this.productIsPack()) {
          if (!this.productIsPack() || (this.productIsPack() && q > 1)) {
            priceItemText.style.display = "inline";
          }
          priceItem.classList.add("price--on-sale");
          priceRegular.style.display = "none";
          priceSale.style.display = "inline-block";
        } else if (priceItem && priceItemText && priceRegular && priceSale) {
          priceItem.classList.remove("price--on-sale");
          priceItemText.style.display = "none";
          priceRegular.style.display = "inline-block";
          priceSale.style.display = "none";
        }

        if (this.productIsBasic()) {
          if (isCardProduct && !this.currentVariant.name.includes("Gift Card")) {
            this.toggleAddButton(
              !cardProduct.variant.available && !cardProduct.variant.isRestocking,
              window.variantStrings.soldOut
            );
          } else {
            this.toggleAddButton(
              !this.singleVariantInStock() && !this.currentVariant.isRestocking,
              window.variantStrings.soldOut
            );
          }
        } else if (isDisplayProduct) {
          this.toggleAddButton(
            !displayProduct.variant.available && !displayProduct.variant.isRestocking,
            window.variantStrings.soldOut
          );
        } else if (this.productIsPreorder()) {
          this.toggleAddButton(
            !this.singleVariantInStock() && !this.currentVariant.isRestocking,
            window.variantStrings.soldOut,
            false,
            true
          );
        } else {
          this.toggleAddButton(
            !this.currentVariant.available && !this.currentVariant.isRestocking,
            window.variantStrings.soldOut
          );
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, preorder = false) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("sold-out");
      if (text) addButtonText.textContent = text;
    } else if (preorder) {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("sold-out");
      addButtonText.textContent = "Preorder";
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("sold-out");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getTapImageData() {
    const tapImageScript = this.querySelector('[type="application/json"]#shopify-tap-images');
    this.tapImageData = this.tapImageData || (tapImageScript ? JSON.parse(tapImageScript.textContent) : null);
    return this.tapImageData;
  }

  getTapImageDataMetal() {
    const tapImageScript = this.querySelector('[type="application/json"]#shopify-metal-tap-images');
    this.tapImageDataMetal = this.tapImageDataMetal || (tapImageScript ? JSON.parse(tapImageScript.textContent) : null);
    return this.tapImageDataMetal;
  }

  getDoubleAndPackImages() {
    const doubleImageScript = this.querySelector('[type="application/json"]#shopify-double-images');
    this.doubleImageData = this.doubleImageData || (doubleImageScript ? JSON.parse(doubleImageScript.textContent) : null);
    
    const packImageScript = this.querySelector('[type="application/json"]#shopify-pack-images');
    this.packImageData = this.packImageData || (packImageScript ? JSON.parse(packImageScript.textContent) : null);

    return {
      doubleImages: this.doubleImageData,
      packImages: this.packImageData
    };
  }

  getDoubleAndPackImagesMetal() {
    const doubleImageScript = this.querySelector('[type="application/json"]#shopify-metal-double-images');
    this.metalDoubleImageData = this.metalDoubleImageData || (doubleImageScript ? JSON.parse(doubleImageScript.textContent) : null);

    const packImageScript = this.querySelector('[type="application/json"]#shopify-metal-pack-images');
    this.metalPackImageData = this.metalPackImageData || (packImageScript ? JSON.parse(packImageScript.textContent) : null);

    return {
      doubleImages: this.metalDoubleImageData,
      packImages: this.metalPackImageData
    };
  }

  getDoubleAndPackImagesDisplayPlateBundle() {
    const doubleImageScript = this.querySelector('[type="application/json"]#shopify-display-plate-bundle-double-images');
    this.displayPlateBundleDoubleImageData = this.displayPlateBundleDoubleImageData || (doubleImageScript ? JSON.parse(doubleImageScript.textContent) : null);

    const packImageScript = this.querySelector('[type="application/json"]#shopify-display-plate-bundle-pack-images');
    this.displayPlateBundlePackImageData = this.displayPlateBundlePackImageData || (packImageScript ? JSON.parse(packImageScript.textContent) : null);

    return {
      doubleImages: this.displayPlateBundleDoubleImageData,
      packImages: this.displayPlateBundlePackImageData
    };
  }

  getQuantityOption() {
    const quantityOptionChecked = document.querySelector(".quantity-options input:checked")?.value;
    if (!quantityOptionChecked) return null;
    const match = quantityOptionChecked.match(/\d+$/);
    const quantity = match ? Number(match[0]) : null;
    return quantity || 1;
  }

  getRestockData() {
    this.restockData =
      this.restockData ||
      JSON.parse(this.querySelector('[type="application/json"]#shopify-restock').textContent);
    return this.restockData;
  }

  getRestockTime() {
    this.restockTime =
      this.restockTime ||
      JSON.parse(this.querySelector('[type="application/json"]#shopify-restock-time').textContent);
    return this.restockTime;
  }

  singleVariantInStock(initialPageLoad) {
    let singleVariant;
    // Gift cards: digital product, never sells out
    // Custom product: made to order, never sells out
    if (
      this.currentVariant.name.includes("Gift Card") ||
      this.currentVariant.name.includes("custom")
    ) {
      return true;
    }
    singleVariant = this.variantData.find(
      (variant) =>
        variant.option1.toLowerCase() ===
        this.currentVariant.option1.toLowerCase(),
    );

    // console.log("SINGLE VARIANT", singleVariant);

    return singleVariant.available;
  }

  productIsBasic() {
    return (
      this.currentVariant.name.toLowerCase().includes("dot.card") ||
      this.currentVariant.name.toLowerCase().includes("dot.thin") ||
      this.currentVariant.name.toLowerCase().includes("dot.classic")
    );
  }

  productIsPreorder() {
    return false;
    // return (
    //   this.currentVariant.name.toLowerCase().includes("dot.display")
    // );
  }

  productIsPack() {
    return (
      this.currentVariant.name.toLowerCase().includes("dot.bundle") ||
      this.currentVariant.name.toLowerCase().includes("dot.duos") ||
      (this.currentVariant.name.toLowerCase().includes("dot.display") &&
      this.getCurrentDisplayProduct().variant.name.toLowerCase().includes("bundle"))
    );
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset")).filter(
      (set) => !set.classList.contains("quantity-fieldset"),
    );
    this.options = fieldsets.map((fieldset) => {
      let value = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
      return value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
